import styled from "styled-components";

const RootContainer = styled.div`
  background-color: white;
`;

const HeaderContainer = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 3;
`;

const ContentContainer = styled.div`
  padding-top: 60px;
  padding-bottom: 50px;
  background-color: white;
`;

const HeaderCloseButtonContainer = styled.div`
  position: absolute;
  left: 10px;
  :hover {
    cursor: pointer;
  }
`;

const HeaderTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

const ToggleButton = styled.button<{ active: boolean }>`
  background-color: ${(props) => (props.active ? "black" : "white")};
  color: ${(props) => (props.active ? "white" : "black")};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  border-radius: 8px;
  width: 100%;
`;

const ValueWithDiscount = styled.span`
  font-size: 12px;
  color: #686868;
`;

const FinishButton = styled.button`
  background-color: black;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  border-radius: 22px;
  width: 100%;
`;

const ValuesSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const ShippingMethodContainer = styled.div<{ active: boolean }>`
  border: ${(props) => (props.active ? `2px` : `1px`)} solid ${(props) => (props.active ? "black" : "#a4a4a4")};
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
`;

const modules = {
  RootContainer,
  HeaderContainer,
  HeaderCloseButtonContainer,
  HeaderTitle,
  ContentContainer,
  ToggleButton,
  FinishButton,
  ValuesSummaryContainer,
  ValueWithDiscount,
  ShippingMethodContainer,
};

export default modules;
